/**
 * @class
 * @description TheoPlayer loader class. It receives Theoplayer instance to listen,
 * intercept and modify the requests if needed.
 * @exports LoaderTheo
 */
export default class LoaderTheo {
    /**
     * Constructs Theo loader object.
     * @param {Object} player Theoplayer player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        player.network.addRequestInterceptor(this._reqInterceptor.bind(this));
    }
    /**
     * Callback for Theoplayer intercepted requests.
     * @param {Object} request Theoplayer intercepted request.
     * @private
     */
    _reqInterceptor(request) {
        request.waitUntil((done) => {
            switch (request.type) {
                case 'manifest':
                    LoaderTheo._engine.setManifestResource(request.url);
                // eslint-disable-next-line no-fallthrough
                case 'segment':
                    LoaderTheo._engine.request(new URL(request.url), true, [
                        (e) => {
                            request.respondWith({
                                body: e.data,
                                status: 200,
                                statusText: 'OK'
                            });
                            done();
                        }
                    ], request.headers);
                    break;
                default:
                    done();
            }
        });
    }
}
